<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">租户权限管理</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="tenantauthForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="8">
            <FormItem label="租户名称" prop="tenantName">
              <Select v-model="form.tenantName" :disabled="disable">
                <Option :value="item.id" v-for="(item, index) in tenantOptions" :key="index">{{item.name}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="权限token" prop="tokenId">
              <Input v-model="form.tokenId" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="16">
            <FormItem label="备注信息" prop="memo">
              <Input v-model="form.memo" :disabled="disable" maxlength="250" show-word-limit type="textarea" ></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit"  v-show="!disable">提交</Button>
    </div>
  </Modal>
</template>

<script>

export default {
  name: 'tenantauth-info',
  data () {
    return {
      form: {},
      isShow: false,
      type: 'add',
      tenantOptions: '',
      disable: false,
      ruleValidate: {
        tenantName: [
          { required: true, message: '租户不允许为空', trigger: 'blur' }
        ],
        tokenId: [
          { required: true, message: '权限token不允许为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      this.$refs.tenantauthForm.validate((valid) => {
        if (valid) {
          switch (this.type) {
            case 'create':
              this.C('admin/tenantauth', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
            case 'update':
              this.U('admin/tenantauth', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
          }
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    }
  },
  mounted: function () {
    this.G('admin/tenant/getTenantByTenant').then(data => {
      this.tenantOptions = data
    })
  }
}
</script>
